interface Props {
  children: React.ReactNode;
}
const Bold = ({ children }: Props) => <strong>{children}</strong>;
export default Bold;
